import { Typography } from '@mui/material'
import { Bank2 as Bank } from '@emotion-icons/bootstrap/Bank2'
import { Colors, Shapes } from 'src/components/theme'
import { ChronologicalList } from 'src/v2/components/chronologic-list'

import styled from '@emotion/styled'
import { ScrollableContainer } from 'src/components/scrollable-container'

const Wrapper = styled.div`
  padding-inline: ${Shapes.spacing[4]}px;
`

const AcquisitionHistoryListInner = () => {
  const items = [
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
    {
      icon: <Bank size={16} />,
      content: (
        <>
          <Typography variant="textmdm">Lorem ipsum dolor sit amet.</Typography>
          <Typography variant="title2l">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
          <Typography variant="text1m">
            Extra content here. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.
          </Typography>
        </>
      ),
    },
  ]

  return (
    <Wrapper>
      <ScrollableContainer height={450} minHeight={450}>
        <ChronologicalList color={Colors.primaryRed700} items={items} />
      </ScrollableContainer>
    </Wrapper>
  )
}

export const AcquisitionHistoryList = () => {
  // TODO: Implement nodata once we have the data
  // if (nodata) {
  //   return (
  //     <WidgetCardEmpty message="It looks like we don't have data for this Owner yet. We're constantly gathering new data, so keep an eye out for updates." />
  //   )
  // }

  return <AcquisitionHistoryListInner />
}
